async function sortProducts() {
    let sortBy = document.getElementById("sort-by").value;
    let tableBody = document.getElementById("productTableBody");
    let rows = Array.from(tableBody.rows);
    let messageRow = document.getElementById("no-products-message");

  const fetchcart = async ()=>{
    const res = await fetch('/cart.js');
    const data = await res.json();
    return data;
  }

    // If message row doesn't exist, create it
    if (!messageRow) {
        messageRow = document.createElement("tr");
        messageRow.id = "no-products-message";
        messageRow.innerHTML = `<td colspan="6" style="text-align: center; font-weight: bold;">No products selected</td>`;
        messageRow.style.display = "none"; // Initially hidden
        tableBody.appendChild(messageRow);
    }

    console.clear();
    console.log("Sorting by:", sortBy);

    // Fisher-Yates Shuffle function
    function shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    // Reset visibility: Show all products before sorting (to reset from previous quantity filtering)
    rows.forEach(row => (row.style.display = ""));

    if (sortBy === "az") {
        rows.sort((a, b) =>
            a.querySelector(".product-name")?.dataset.name.localeCompare(
                b.querySelector(".product-name")?.dataset.name
            )
        );
    } else if (sortBy === "za") {
        rows.sort((a, b) =>
            b.querySelector(".product-name")?.dataset.name.localeCompare(
                a.querySelector(".product-name")?.dataset.name
            )
        );
    } else if (sortBy === "price-low-high") {
        rows.sort((a, b) =>
            parseFloat(a.querySelector(".product-price")?.dataset.price) -
            parseFloat(b.querySelector(".product-price")?.dataset.price)
        );
    } else if (sortBy === "price-high-low") {
        rows.sort((a, b) =>
            parseFloat(b.querySelector(".product-price")?.dataset.price) -
            parseFloat(a.querySelector(".product-price")?.dataset.price)
        );
    } else if ( sortBy === "featured") {
        rows = shuffle(rows);
    }  else if (sortBy === "quantity") {
        const data = await fetchcart();
        let selectedProducts = [];
        const cartItemIds = data.items.map(item => item.variant_id.toString());

        rows.forEach(row => {
            let quantityInput = row.querySelector("input[name='quantity']");
            let quantityValue = quantityInput ? parseInt(quantityInput.value) : 0;
          
            const productId = row.getAttribute('data-variant-id');
            const cartItem = data.items.find(item => item.variant_id.toString() === productId);
          
            if (cartItem) {
            
              if (quantityInput) {
                quantityInput.value = cartItem.quantity;
              }
            } else {
              row.style.display = "none";
            }

            if (data?.items?.length > 0) {
                selectedProducts.push(row);
            } else {
                row.style.display = "none";
            }
        });

        if (data?.items?.length <= 0) {
            messageRow.style.display = "";
        } else {
            messageRow.style.display = "none";
        }

        selectedProducts.sort((a, b) =>
            parseInt(b.querySelector("input[name='quantity']").value) -
            parseInt(a.querySelector("input[name='quantity']").value)
        );        
    } else {
        messageRow.style.display = "none";
    }

    tableBody.innerHTML = "";
    rows.forEach(row => tableBody.appendChild(row));

    if (sortBy === "quantity" && messageRow.style.display === "") {
        tableBody.appendChild(messageRow);
    }
}


function changeQuantity(button, change) {
  let inputField = button.parentElement.querySelector("input[type='number']");
  let currentValue = parseInt(inputField.value, 10);

  // Set initial value to 0 if input field is empty or invalid
  if (isNaN(currentValue)) {
    currentValue = 0;
  }

  // Update the value based on the change, and allow the value to go down to 0
  let newValue = currentValue + change;
  inputField.value = newValue;
}


function addToCart(variantId) {
  var quantityElement = document.getElementById("quantity-" + variantId);
  var quantity = quantityElement ? parseInt(quantityElement.value) : 0;

  // If quantity is zero, remove the product from the cart
  if (quantity <= 0) {
    updateCart(variantId, 0);
    showCartAlert("❌ No products selected. Increase quantity to add.", true);
    return;
  }

  // Update the product quantity in the cart
  updateCart(variantId, quantity);
}

// Function to update the cart with the exact quantity
function updateCart(variantId, quantity) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates: { [variantId]: quantity },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      updateCartCount();
      if (quantity > 0) {
        showCartAlert("✅ Product quantity updated!", false);
      }
    })
    .catch((error) => console.error("Error updating cart:", error));
}

function showCartAlert(message, isError) {
  var alertBox = document.getElementById("cart-alert");
  alertBox.style.display = "flex";
  alertBox.style.opacity = "1";
  alertBox.style.backgroundColor = isError ? "#ff2e2e" : "green"; // Red for error, green for success
  alertBox.innerText = message; // Update text message

  console.log(message);

  // Hide the alert after 4 seconds
  setTimeout(function () {
    alertBox.style.opacity = "0";
    setTimeout(() => {
      alertBox.style.display = "none";
    }, 500); // Wait for fade-out transition
  }, 4000);
}

function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      let count = data.item_count;
      let cartCountElement = document.getElementById("cart-count");

      if (cartCountElement) {
        cartCountElement.textContent = count;
      }
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

// Call the function on page load to show the correct cart count
document.addEventListener("DOMContentLoaded", updateCartCount);

function filterTable() {
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("searchBar");
  filter = input.value.toUpperCase();
  table = document.getElementById("productTable");
  tr = table.getElementsByTagName("tr");

  for (i = 1; i < tr.length; i++) {
    var productName = tr[i].getElementsByClassName("product-name")[0];
    var productSku = tr[i].getElementsByClassName("product-sku")[0];

    if (productName && productSku) {
      var nameText = productName.textContent || productName.innerText;
      var skuText = productSku.textContent || productSku.innerText;

      if (
        nameText.toUpperCase().includes(filter) ||
        skuText.toUpperCase().includes(filter)
      ) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", updateCartCount);
function openCartModal() {
  fetch("/cart.js") // Fetch cart data
    .then((response) => response.json())
    .then((data) => {
      let cartItems = data.items;
      let modalBody = document.getElementById("cartModalBody");
      let totalQuantity = 0;
      let totalOriginalPrice = 0; // Sum of all original prices
      let totalFinalPrice = 0; // Sum of all final prices (to pay)
      let totalDiscount = 0; // Sum of all discounts
      modalBody.innerHTML = ""; // Clear previous content

      if (cartItems.length === 0) {
        modalBody.innerHTML =
          "<tr class='ctm-empty-cart'><td colspan='5'>Your cart is empty.</td></tr>";
      } else {
        cartItems.forEach((item) => {
          totalQuantity += item.quantity;

          let originalPrice = item.original_line_price / 100; // Original total price (before discount)
          let finalPrice = item.final_line_price / 100; // Final total price (after discount)
          let discountAmount = originalPrice - finalPrice; // Discount received

          totalOriginalPrice += originalPrice; // Add to total original price
          totalFinalPrice += finalPrice; // Add to total final price
          totalDiscount += discountAmount; // Add to total discount

          let priceHTML = `<span><strong> $${finalPrice.toFixed(2)}</strong></span>`;

          // Show original price and discount only if there's a discount
          if (discountAmount > 0) {
            priceHTML = `
            <div class="ctm-price-wrap">
              <span class="ctm-sub-total"> <s>$${originalPrice.toFixed(2)}</s></span>
              <span class="ctm-discount"> -$${discountAmount.toFixed(2)}</span>
              <span class="ctm-total-price"><strong> $${finalPrice.toFixed(2)}</strong></span>
              </div>
            `;
          }

          // Retrieve variant options with `data-option-name`
          let variantHTML = "";
          if (item.variant_title && item.variant_title !== "Default Title") {
            let variantOptions = item.variant_title.split(" / ");
            let optionNames = item.options_with_values || []; // Shopify provides options with names
            
            variantHTML = `<div class="ctm-variant-names">`;
            variantOptions.forEach((option, index) => {
              let optionName = optionNames[index] ? optionNames[index].name : `Option ${index + 1}`;
              variantHTML += `<div class="ctm-option"><span class="option-name">${optionName}:</span> <span class="option-value">${option}</span></div>`;
            });
            variantHTML += `</div>`;
          }

          if (window.matchMedia("(max-width: 768px)").matches) {
            // Mobile version
            modalBody.innerHTML += `
                  <tr>
                      <td class="ctm-cart-img"><img src="${item.image}" alt="Product Image"></td>
                      <td class="cart-details-container">
                          <div class="ctm-cart-details">
                              <span>${item.product_title}</span>
                              ${variantHTML}
                              <span>SKU: ${item.sku || "N/A"}</span>
                              <span>${priceHTML}</span>
                          </div>
                      </td>
                      <td>${item.quantity}</td>
                  </tr>
              `;
          } else {
            // Desktop version
            modalBody.innerHTML += `
                  <tr>
                      <td><img src="${item.image}" alt="Product Image"></td>
                      <td>${item.product_title} <span>${variantHTML}</span></td>
                      <td>${item.sku || "N/A"}</td>
                      <td>${priceHTML}</td>
                      <td>${item.quantity}</td>
                  </tr>
              `;
          }
        });
      }

      // Update Quantity Heading with Total Quantity
      document.getElementById(
        "quantityHeading"
      ).innerHTML = `Quantity (Total: ${totalQuantity})`;

      // Update Total Price Breakdown
      document.querySelector("#cartTotal").innerHTML = `
       <div class="ctm-price ctm-sub-total"><p>Sub Total:</p> <s>$${totalOriginalPrice.toFixed(2)}</s></div>
      <div class="ctm-price ctm-discount"><p>Congratulation You Saved! </p><p>-$${totalDiscount.toFixed(2)}</p></div>
        <div class="ctm-price ctm-total-price"><p>Total Price: </p><p>$${totalFinalPrice.toFixed(2)}</p></div>
      `;

      document.getElementById("cartModal").style.display = "flex"; // Show modal
    })
    .catch((error) => console.error("Error fetching cart:", error));
}



function closeCartModal() {
  document.getElementById("cartModal").style.display = "none";
}

// Close modal if clicked outside the content
window.onclick = function (event) {
  let modal = document.getElementById("cartModal");
  if (event.target == modal) {
    modal.style.display = "none";
  }
};

function openModal(image) {
  var modal = document.getElementById("imageModal");
  var modalImg = document.getElementById("modalImage");

  modal.style.display = "flex";
  modalImg.src = image.src.replace("100x100", "600x600"); // Change image size dynamically
}

// Close the modal when clicking outside the image
function closeModal() {
  document.getElementById("imageModal").style.display = "none";
}

function openModal(imageElement) {
  let modal = document.getElementById("imageModal");
  let modalImage = document.getElementById("modalImage");
  let modalTitle = document.getElementById("modalTitle");
  let modalDesc = document.getElementById("modalDesc");

  // Get product details from the clicked row
  let row = imageElement.closest("tr");
  let title = row.getAttribute("data-name");
  let description = row.getAttribute("data-description");

  // Decode HTML entities
  let decodedDescription = new DOMParser().parseFromString(
    description,
    "text/html"
  ).body.textContent;

  // Remove HTML tags
  let plainTextDescription = decodedDescription.replace(/<\/?[^>]+(>|$)/g, "");

  // Set modal content
  modalImage.src = imageElement.src;
  modalTitle.textContent = title;
  modalDesc.textContent = plainTextDescription;

  // Show modal
  modal.style.display = "flex";

  // Disable scrolling
  document.body.style.overflow = "hidden";
}

function closeModal() {
  let modal = document.getElementById("imageModal");
  modal.style.display = "none";

  // Enable scrolling when modal is closed
  document.body.style.overflow = "";
}
